import { type FC } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import css from './styles.module.scss';

interface ContractRibbonAnimationProps {
  isUninitialized: boolean;
}

const ContractRibbonAnimation: FC<ContractRibbonAnimationProps> = ({
  isUninitialized,
}) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full">
      <div className="relative w-full h-full overflow-hidden rounded-lg">
        <motion.div
          className={cn(
            'absolute top-1/2',
            isUninitialized ? css.gradientLine : 'bg-accent',
          )}
          initial={{
            width: '9.0625rem',
            height: '14.375rem',
            left: '-211%',
            y: '-50%',
            rotate: '30deg',
          }}
          animate={{
            width: '1.25rem',
            height: '11.875rem',
            left: '131.25%',
            y: '-50%',
            rotate: '30deg',
          }}
          transition={{ delay: isUninitialized ? 1.1 : 1.3, duration: 0.6 }}
        ></motion.div>
      </div>
    </div>
  );
};

export { ContractRibbonAnimation };
